import { ACTIVATE_LAYER, DEACTIVATE_LAYER, INIT_LAYERS_CONF } from '../actions/layerActions';

const initialState = {
  'buttonsLayersState': {},
  'sources': {},
  'layers': [],
  'getFeatureInfoAttrs': {},
  'base_layer': ''
};

const layerReducer = (state = initialState, action) => {
  const returnedState = Object.assign({}, state);
  switch(action.type) {
    case ACTIVATE_LAYER:
      if(state['buttonsLayersState'][`${action.payload}`].active) {
        console.log('Can not do activate');
        return returnedState;
      }
      returnedState['buttonsLayersState'][`${action.payload}`].active = true;
      return returnedState;
    case DEACTIVATE_LAYER:
      if(!state['buttonsLayersState'][`${action.payload}`].active) {
        console.log('Can not do deactivate');
        return returnedState;
      }
      returnedState['buttonsLayersState'][`${action.payload}`].active = false;
      return returnedState;
    
    case INIT_LAYERS_CONF:
      return action.payload;

    default : return returnedState;
  }
};

export default layerReducer;